const labelChipStyles = {
    fontFamily: 'Avenir-Black',
    fontWeight: 800,
};
const bigChip = {
    paddingRight: 0.5,
    '& .MuiChip-label': {
        ...labelChipStyles,
        p: 0.5,
        fontSize: 14,
        lineHeight: 14,
    },
};
const smallChip = {
    paddingRight: 1,
    height: 20,
    '& .MuiChip-label': {
        ...labelChipStyles,
        p: 0.2,
        fontSize: 10,
        lineHeight: 10,
    },
};
const salesUpChip = {
    color: 'primary.main',
    bgcolor: 'rgba(68, 165, 107, 0.2)',
    '& .MuiChip-icon': {
        color: '#44A56B',
    },
};
const salesDownChip = {
    color: 'primary.main',
    bgcolor: 'rgba(171, 18, 18, 0.2);',
    '& .MuiChip-icon': {
        color: '#AB1212',
    },
};
const salesEqualChip = {
    color: 'primary.main',
    bgcolor: 'rgba(0, 76, 96, 0.2)',
    '& .MuiChip-icon': {
        color: 'primary.light',
    },
};
export default {
    bigChip,
    smallChip,
    salesUpChip,
    salesDownChip,
    salesEqualChip,
};
